import styled from "styled-components";

export const Title = styled.h1`
  font-size: 2em;
  color: palevioletred;
`;

export const Head = styled.div`
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  padding: 15px;
`;
